import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import xBlog from '../components/content/blog.vue'
import xAbout from '../components/content/about.vue'
import xProduction from '../components/content/production.vue'
import xOther from '../components/content/other.vue'

export default new Router({
    mode: 'history',
    base: '/',
    routes: [
        {
            path:'/',
            component: xProduction
        },
        {
            path:'/blog',
            component: xBlog
        },
        {
            path:'/about',
            component: xAbout
        },
        {
            path:'/production',
            component: xProduction
        },
        {
            path:'/other',
            component: xOther
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js